import { Endpoints, isUriAllowed as isAllowed } from '@amzn/showtime';
export const uriAllowList = [
    Endpoints.ATOZ,
    Endpoints.HUB,
    'http://localhost:3000',
];
export default function isUriAllowed(uri) {
    return isAllowed({ uri, uriAllowList });
}
//# sourceMappingURL=UriAllowList.js.map